import '../../utils/fix.cross-origin'
import LoadingModal from './lnk-loading-modal';

/**
 * @createdBy:HuangJian
 * @date:2018/12/5
 * @params：
 * @description：加载动画的管理器
 */
LoadingModal.createService = (props) => {

    const properties = props || {};
    const instance = new Vue({
        data: properties,
        render(h){
            return h(LoadingModal, {props: properties});
        },
        destory(){
            const doc = window.CURRENT_ORIGIN_TOP.window.document || document;
            const modals = doc.getElementsByClassName('lnk-loading-modal') || [];
            modals.forEach((child) => {
                doc.body.removeChild(child);
            });
        }
    });

    const handler = instance.$mount();

    const doc = window.CURRENT_ORIGIN_TOP.window.document || document;

    doc.body.appendChild(handler.$el);

    const component = instance.$children[0];

    return {
        open(message){
            return component.requestShow(message);
        },
        hide(tag){
            return component.requestHide(tag);
        },
        close(){
            return component.requestClose();
        }
    };
};

export default LoadingModal;
